import { defineStore } from 'pinia'
import { ref } from 'vue'
import type {
  AdminConfiguratorEventsType,
  AdminConfiguratorTemplateItemType,
} from '@/entities/Cabinet'
import useValidate from '@/shared/lib/validate'
import { useTranslate } from '@/shared/lib'
import { cloneDeep } from 'lodash'

const useModel = defineStore('cabinet_admin_config_template_form', () => {
  const { required } = useValidate()
  const { trs } = useTranslate()

  const openForm = ref(false)

  /* Данные формы */
  const fields: {
    id: number | null
    name: string
    owner_group_id: number
    template: AdminConfiguratorTemplateItemType[]
  } = {
    id: null,
    name: '',
    owner_group_id: 1,
    template: [],
  }

  const data = ref(cloneDeep(fields))

  /* Правила валидации */
  const rules = {
    name: [(value: string) => required(value)],
  }

  /**
   * Функция очистки формы после закрытия
   */
  const closeForm = () => {
    openForm.value = false
    data.value = cloneDeep(fields)
  }

  /**
   * Настройки шапки формы
   */
  const headers = ref<any>([
    { title: '№', key: 'index', sortable: false },
    { title: trs('itf.pin_number'), key: 'pin', sortable: false },
    { title: trs('itf.type'), key: 'event', sortable: false },
    { title: trs('itf.control'), key: 'action', sortable: false, align: 'end' },
  ])

  /**
   * Функция удаления строки
   * @param pin_number
   */
  const deleteRow = (pin_number: number) => {
    data.value.template = data.value.template.filter((item) => item.pin != pin_number)
  }

  /**
   * Функция добавления строки
   * @param pin
   * @param event
   */
  const addRow = (pin: number, event: AdminConfiguratorEventsType) => {
    data.value.template.push({
      pin,
      event: event.id,
      type_name: event.event_type,
    })
  }

  return {
    openForm,
    fields,
    data,
    rules,
    headers,

    deleteRow,
    addRow,
    closeForm,
  }
})

export { useModel }
